import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link
            to="/"
            className="flex items-center gap-2.5 group whitespace-nowrap"
          >
            <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center group-hover:bg-primary-600 transition-colors">
              <i className="ri-trophy-line text-background-50 text-lg"></i>
            </div>
            <span className={`font-heading text-lg font-semibold transition-colors ${scrolled ? 'text-foreground-900' : 'text-foreground-50'}`}>
              每日大赛
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === '/'
                  ? scrolled
                    ? 'text-primary-600 bg-primary-50'
                    : 'text-primary-300 bg-white/10'
                  : scrolled
                    ? 'text-foreground-700 hover:text-foreground-900 hover:bg-background-100'
                    : 'text-foreground-100/80 hover:text-foreground-50 hover:bg-white/10'
              }`}
            >
              首页
            </Link>
            <div className="relative group">
              <button
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap flex items-center gap-1 ${
                  location.pathname.startsWith('/category')
                    ? scrolled
                      ? 'text-primary-600 bg-primary-50'
                      : 'text-primary-300 bg-white/10'
                    : scrolled
                      ? 'text-foreground-700 hover:text-foreground-900 hover:bg-background-100'
                      : 'text-foreground-100/80 hover:text-foreground-50 hover:bg-white/10'
                }`}
              >
                赛事分类
                <i className="ri-arrow-down-s-line text-sm"></i>
              </button>
              <div className="absolute top-full left-1/2 -translate-x-1/2 pt-2 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200">
                <div className="bg-background-50 rounded-xl border border-background-200/60 p-2 min-w-[200px] shadow-lg">
                  {categories.map((cat) => (
                    <Link
                      key={cat.slug}
                      to={`/category/${cat.slug}`}
                      className="flex items-center gap-2.5 px-3 py-2.5 rounded-lg text-sm text-foreground-700 hover:text-foreground-900 hover:bg-background-100 transition-colors whitespace-nowrap"
                    >
                      <i className={`${cat.icon} text-base`}></i>
                      <span>{cat.name}</span>
                      <span className="ml-auto text-xs text-foreground-400">{cat.count}场</span>
                    </Link>
                  ))}
                </div>
              </div>
            </div>
            <Link
              to="/about"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === '/about'
                  ? scrolled
                    ? 'text-primary-600 bg-primary-50'
                    : 'text-primary-300 bg-white/10'
                  : scrolled
                    ? 'text-foreground-700 hover:text-foreground-900 hover:bg-background-100'
                    : 'text-foreground-100/80 hover:text-foreground-50 hover:bg-white/10'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button className="px-5 py-2 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">
              立即参与
            </button>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg"
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            <i
              className={`text-xl transition-colors ${scrolled ? 'text-foreground-900' : 'text-foreground-50'} ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}
            ></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/60">
          <div className="px-4 py-3 space-y-1">
            <Link
              to="/"
              className="block px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors"
            >
              首页
            </Link>
            <div className="px-4 py-2 text-xs font-medium text-foreground-400">赛事分类</div>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="flex items-center gap-2.5 px-4 py-3 rounded-lg text-sm text-foreground-700 hover:bg-background-100 transition-colors"
              >
                <i className={`${cat.icon} text-base`}></i>
                <span>{cat.name}</span>
              </Link>
            ))}
            <Link
              to="/about"
              className="block px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors"
            >
              关于我们
            </Link>
            <button className="w-full mt-2 px-5 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">
              立即参与
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}